module.exports = __webpack_public_path__ + "img/13.f820d7fa.png";